//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { STORAGE_KEY } from "../../utils/define";

export default {
  name: "HumanList",
  components: {},
  props: {
    list: Array,
    isAddSpare: Boolean,
    modelID: Number,
    backGround: String,
    width: String,
    disable:Boolean,
  },

  data() {
    return {
      data: [],
      spareList: this.list,
      addSpare:false,// this.isAddSpare || false,
      modelViewId: this.modelID,
      comBackGround: this.backGround,
      activeBackGround: this.backGround,
      activeWidth: this.width,
      
    };
  },
  mounted() {
    setTimeout(() => {
      console.log('----------move 1')
      let firtLeft = document.getElementById(`spareObj_${this.spareList[0].id}`).getBoundingClientRect().left
      if (
        this.spareList.length > 0 &&
        this.spareList[0].id != this.modelViewId
      ) {
        document.getElementById(`spareObj_${this.modelViewId}`) &&
          document.getElementById("boxListScroll") &&
          document.getElementById("boxListScroll").scrollTo({
            left:
              document
                .getElementById(`spareObj_${this.modelViewId}`)
                .getBoundingClientRect().left - firtLeft ,
            behavior: "smooth",
          });
      }
    },2000);
    let localModelID = localStorage.getItem(STORAGE_KEY.MODEL_ID);
    if (localModelID && (!this.modelViewId || this.modelViewId == "")) {
      this.modelViewId = localModelID;
    }
    console.log("===this modelID", this.modelViewId, this.spareList);
  },
  beforeDestroy() {},
  methods: {
    onAddSpare() {
      this.$emit("onAddSpare");
    },
    selectSpare(data) {
      console.log("------select spareID", data);
      if(this.disable){
        return
      }
      if (this.modelViewId == data.id) {
        return;
      }
      this.$emit("selectSpare", {
        id: data.id,
      });

      this.modelViewId = data.id;
      localStorage.setItem(STORAGE_KEY.MODEL_ID, data.id);
      localStorage.setItem(STORAGE_KEY.MODEL_NAME, data.name);
    },
  },
  watch: {
    list(list) {
      console.log('----------move 2')
      this.spareList = list;
      // if (
      //   this.spareList.length > 0 &&
      //   this.spareList[0].id != this.modelViewId
      // ) {
      //   //第一个不需要移动
      //   //列表初始化之后，定位到默认选择的分身上
      //   this.$nextTick(() => {
      //     document.getElementById(`spareObj_${this.modelViewId}`) &&
      //       document.getElementById("boxListScroll") &&
      //       document.getElementById("boxListScroll").scrollTo({
      //         left:
      //           document
      //             .getElementById(`spareObj_${this.modelViewId}`)
      //             .getBoundingClientRect().left,
      //         behavior: "smooth",
      //       });
      //   });
      // }
    },
    isAddSpare(data) {
      this.addSpare = data;
    },
    modelID(data) {
      this.modelViewId = data;
    },
    backGround(data) {
      console.log("change background", data);
      this.comBackGround = data;
    },
  },
};



// WEBPACK FOOTER //
// ./src/myComponents/HumanList/HumanList.vue